import React from 'react';
import { appConfig } from '../../appConfig';

const RefreshPageComponent = () => {
  const { RefreshPageComponent } = appConfig;

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <button
      id="Refresh"
      title={RefreshPageComponent.title}
      onClick={handleRefresh}
      className="map-icon"
    >
      <img
        src={RefreshPageComponent.icon}
        alt={RefreshPageComponent.altText}
      />
    </button>
  );
};

export default RefreshPageComponent;
